import { Service } from '@/tools'
export class NoBookService<T extends TCommodity.NoBook> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TCommodity.NoBook}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }
  // 创建 批量提交并新建
  batchSaveSubmit = <K extends T['ApiBatchSaveSubmit']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiBatchSaveSubmit', data)
  // 创建 提交并新建
  saveSubmit = <K extends T['ApiSaveSubmit']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiSaveSubmit', data)
  // 编辑 批量保存
  batchUpdate = <K extends T['ApiBatchUpdate']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiBatchUpdate', data)
  // 编辑 基本信息 批量保存
  batchUpdateBasicInformation = <K extends T['ApiBatchUpdateBasicInformation']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiBatchUpdateBasicInformation', data)
  // 编辑 基本信息 批量提交并下一条
  batchUpdateSubmitBasicInformation = <K extends T['ApiBatchUpdateSubmitBasicInformation']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiBatchUpdateSubmitBasicInformation', data)
  // 编辑 提交并下一条
  updateSubmit = <K extends T['ApiUpdateSubmit']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdateSubmit', data)
  // 编辑 批量提交并下一条
  updateUpdateSubmit = <K extends T['ApiUpdateUpdateSubmit']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdateUpdateSubmit', data)
  // 编辑 保存
  update = <K extends T['ApiUpdate']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdate', data)

  // 创建 基本信息 批量提交并新建
  batchSaveSubmitBasicInformation = <K extends T['ApiBatchSaveSubmitBasicInformation']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiBatchSaveSubmitBasicInformation', data)

  // 非图查看详情
  selectCommodityNoBookDetail = <K extends T['ApiSelectCommodityNoBookDetail']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiSelectCommodityNoBookDetail', data)
}
